let lastId: number = 0;

export const uniqueId = (prefix?: string) => {
  lastId += 1;
  return `${prefix ? `${prefix}-` : ''}${lastId}`;
};
